var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPointsDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.012 13.092C7.412 13.092 6.884 12.976 6.428 12.744C5.972 12.504 5.62 12.172 5.372 11.748C5.124 11.324 5 10.832 5 10.272V7.308C5 6.748 5.124 6.256 5.372 5.832C5.62 5.408 5.972 5.08 6.428 4.848C6.884 4.616 7.412 4.5 8.012 4.5C8.604 4.5 9.128 4.612 9.584 4.836C10.04 5.06 10.392 5.376 10.64 5.784C10.888 6.192 11.012 6.664 11.012 7.2C11.012 7.24 10.996 7.276 10.964 7.308C10.94 7.332 10.908 7.344 10.868 7.344L9.764 7.404C9.668 7.404 9.62 7.36 9.62 7.272C9.62 6.8 9.472 6.42 9.176 6.132C8.888 5.844 8.5 5.7 8.012 5.7C7.524 5.7 7.132 5.844 6.836 6.132C6.54 6.42 6.392 6.8 6.392 7.272V10.332C6.392 10.796 6.54 11.172 6.836 11.46C7.132 11.748 7.524 11.892 8.012 11.892C8.5 11.892 8.888 11.752 9.176 11.472C9.472 11.184 9.62 10.804 9.62 10.332C9.62 10.244 9.668 10.2 9.764 10.2L10.868 10.248C10.908 10.248 10.94 10.26 10.964 10.284C10.996 10.308 11.012 10.336 11.012 10.368C11.012 10.912 10.888 11.392 10.64 11.808C10.392 12.216 10.04 12.532 9.584 12.756C9.128 12.98 8.604 13.092 8.012 13.092Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPointsDisabled);
export default __webpack_public_path__ + "static/media/icon_points_disabled.2e2047240a9a28af107df250e3842699.svg";
export { ForwardRef as ReactComponent };